// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".action[data-v-5677f311] {\n  padding: 3px 10px;\n}\n.end[data-v-5677f311] {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
